import { fetchOmni } from './utils.js';

export const generateToken = async (env, clientId, sid, typeKey) =>
  (
    await fetchOmni(env, `/api/jwt/${clientId}/?ANsid=${sid}`, {
      method: 'POST',
      body: JSON.stringify({
        omniTypeKeys: [typeKey],
        withRoles: true,
      }),
    })
  ).jwt;
